import React from 'react';
import { useDashboard } from '../DashboardContext';

const DashboardHeader: React.FC = () => {
    const { selectedInstituteName, loading } = useDashboard();

    return (
        <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
                <h3 className="font-26 font-600 mb-0">User Activity Dashboard</h3>
                {selectedInstituteName && (
                    <div className="text-muted small mt-1">
                        <i className="bi bi-mortarboard me-1"></i>{selectedInstituteName}
                        {loading && <span className="spinner-border spinner-border-sm ms-2" style={{ width: 12, height: 12 }}></span>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default DashboardHeader;
